import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  TextField,
  Stack,
  Grid
} from '@mui/material';
import {
  WhatsApp,
  AccessTime,
  HourglassEmpty,
  MailOutline,
  Send,
  Instagram
} from '@mui/icons-material';

class SupportPage extends Component {
  constructor(props) {
    super(props);
    // Definindo o estado inicial da classe
    this.state = {
      name: '',
      email: '',
      message: ''
    };

    // Binding dos métodos para garantir o escopo do 'this'
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    console.log('Dados enviados via Class Component:', this.state);
    // Aqui entra a lógica de envio do formulário
  }

  render() {
    return (
      <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh', py: 0 }}>


        {/* --- HEADER --- */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: '50%',
                  border: '3px double #6200ee',
                  display: 'inline-block'
                }}
              />
              <Typography variant="h6" fontWeight="bold" color="#2b2b2b">
                Suporte fazpedido
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary">
              Estamos aqui para garantir a melhor experiência
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<WhatsApp />}
            sx={{
              bgcolor: '#6200ee',
              borderRadius: 3,
              textTransform: 'none',
              fontWeight: 'bold',
              '&:hover': { bgcolor: '#4b00b4' }
            }}
          >
            WhatsApp
          </Button>
        </Box>

        {/* --- TOP INFO BAR --- */}
        <Card sx={{ mb: 4, borderRadius: 4, bgcolor: '#f3f0ff', boxShadow: 'none' }}>
          <CardContent sx={{ py: '16px !important' }}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <Box display="flex" alignItems="flex-start" gap={1.5}>
                  <AccessTime sx={{ color: '#6200ee', mt: 0.3 }} />
                  <Box>
                    <Typography variant="subtitle2" fontWeight="bold" color="#2b2b2b">
                      Horário de atendimento
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Segunda a sexta, 09h às 18h (Brasília)
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box display="flex" alignItems="flex-start" gap={1.5}>
                  <HourglassEmpty sx={{ color: '#6200ee', mt: 0.3 }} />
                  <Box>
                    <Typography variant="subtitle2" fontWeight="bold" color="#2b2b2b">
                      Tempo de resposta
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Menos de 2 horas úteis
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* --- MAIN CONTENT (FORM & SIDEBAR) --- */}
        <Grid container spacing={3}>

          {/* Form Column */}
          <Grid size={{ xs: 12, md: 7 }}>
            <Card sx={{ borderRadius: 4, boxShadow: '0px 2px 8px rgba(0,0,0,0.04)', height: '100%' }}>
              <CardContent sx={{ p: 4 }}>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <MailOutline sx={{ color: '#6200ee' }} />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Fale com o suporte
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" mb={3}>
                  Envie sua mensagem e responderemos em até 2 horas úteis.
                </Typography>

                <Box component="form" onSubmit={this.handleSubmit} noValidate>
                  <Typography variant="body2" fontWeight="bold" mb={1} color="#2b2b2b">
                    Seu nome
                  </Typography>
                  <TextField
                    fullWidth
                    name="name"
                    placeholder="Como podemos te chamar?"
                    variant="outlined"
                    value={this.state.name}
                    onChange={this.handleChange}
                    sx={{ mb: 2.5, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />

                  <Typography variant="body2" fontWeight="bold" mb={1} color="#2b2b2b">
                    Seu email
                  </Typography>
                  <TextField
                    fullWidth
                    name="email"
                    type="email"
                    placeholder="voce@empresa.com"
                    variant="outlined"
                    value={this.state.email}
                    onChange={this.handleChange}
                    sx={{ mb: 2.5, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />

                  <Typography variant="body2" fontWeight="bold" mb={1} color="#2b2b2b">
                    Como podemos ajudar?
                  </Typography>
                  <TextField
                    fullWidth
                    name="message"
                    placeholder="Descreva sua dúvida ou problema aqui..."
                    variant="outlined"
                    multiline
                    rows={4}
                    value={this.state.message}
                    onChange={this.handleChange}
                    sx={{ mb: 3, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    startIcon={<Send />}
                    sx={{
                      bgcolor: '#6200ee',
                      borderRadius: 2,
                      textTransform: 'none',
                      px: 3,
                      py: 1,
                      fontWeight: 'bold',
                      '&:hover': { bgcolor: '#4b00b4' }
                    }}
                  >
                    Enviar mensagem
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Sidebar Column */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Stack spacing={3}>

              {/* Direct Contact */}
              <Card sx={{ borderRadius: 4, boxShadow: '0px 2px 8px rgba(0,0,0,0.04)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="subtitle1" fontWeight="bold" mb={0.5}>
                    Contato direto
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mb={2}>
                    Prefere email direto? Use o endereço abaixo.
                  </Typography>

                  <Box
                    sx={{
                      bgcolor: '#f8f9fa',
                      p: 2,
                      borderRadius: 2,
                      border: '1px solid #e0e0e0',
                      mb: 1.5,
                      fontFamily: 'monospace',
                      color: '#2b2b2b'
                    }}
                  >
                    contato@fazpedido.com.br
                  </Box>

                  <Button
                    fullWidth
                    variant="outlined"
                    startIcon={<MailOutline />}
                    href="mailto:contato@fazpedido.com.br"
                    sx={{
                      borderColor: '#e0e0e0',
                      color: '#2b2b2b',
                      borderRadius: 2,
                      textTransform: 'none',
                      fontWeight: 'bold',
                      py: 1,
                      '&:hover': { borderColor: '#b5b5b5', bgcolor: '#f8f9fa' }
                    }}
                  >
                    Abrir email
                  </Button>
                </CardContent>
              </Card>

              {/* Social Media */}
              <Card sx={{ borderRadius: 4, boxShadow: '0px 2px 8px rgba(0,0,0,0.04)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                    <Instagram sx={{ color: '#6200ee' }} />
                    <Typography variant="subtitle1" fontWeight="bold">
                      Siga-nos
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" mb={2}>
                    Acompanhe novidades e dicas no Instagram.
                  </Typography>

                  <Stack spacing={1}>
                    <Button
                      fullWidth
                      variant="text"
                      startIcon={<Instagram />}
                      href="https://instagram.com/fazpedido.app"
                      target="_blank"
                      sx={{
                        bgcolor: '#f1effb',
                        color: '#2b2b2b',
                        justifyContent: 'flex-start',
                        borderRadius: 2,
                        textTransform: 'none',
                        py: 1,
                        px: 2,
                        fontWeight: 'bold',
                        '&:hover': { bgcolor: '#e5e0fa' }
                      }}
                    >
                      @fazpedido.app
                    </Button>


                  </Stack>
                </CardContent>
              </Card>

            </Stack>
          </Grid>

        </Grid>

      </Box>
    );
  }
}

export default SupportPage;